import { useState } from 'react'
import NotImplemented from './NotImplemented'
import OperationsSelector from './OperationsSelector'
import TaxiOperations from './Taxi/TaxiOperations'

export const Operations = () => {
  const [activeSelection, setActiveSelection] = useState<string>()

  return (
    <>
      {activeSelection === undefined && (
        <OperationsSelector setActiveSelection={setActiveSelection} />
      )}
      {activeSelection === 'Taxi' && <TaxiOperations />}
      {activeSelection === 'Coach' && <NotImplemented />}
      {activeSelection === 'CarRental' && <NotImplemented />}
      {activeSelection === 'MicroMobility' && <NotImplemented />}
    </>
  )
}
export default Operations
